<template>
  <div
    :class="['product-buy-button-fi', shopType ? `product-buy-button-fi--${shopType}` : '']"
    @click.stop
  >
    <loading-indicator-wrapper
      :loading="isInProgress"
      dark
      variant="spinnerLocal"
      spinoff="in-relative-centered"
      :class="[
        'product-buy-button-fi__loader-wrapper',
        shopType ? `product-buy-button-fi__loader-wrapper--${shopType}` : '',
        inline ? 'product-buy-button-fi__loader-wrapper--inline' : '',
      ]"
    >
      <button-fi
        v-if="!isButtonHidden"
        :disabled="isButtonDisabled"
        :data-productid="item ? item.ID : null"
        :data-productname="item ? `${item.ID} - ${item.catalogProductData.ProductName}` : null"
        :aria-label="$dict.get('checkout.Cart.Add-Basket')"
        type="button"
        :class="[
          'button-fi__icon',
          'button-fi__primary',
          'product-buy-button-fi__cart-button',
          shopType ? `product-buy-button-fi__cart-button--${shopType}` : '',
        ]"
        data-test="product-buy-button"
        :data-test-2="isButtonDisabled ? 'product-buy-button-disabled' : null"
        @click.stop="$emit('add-product', productDetails)"
      >
        <icon-fi
          icon="shopping-cart"
          color="white"
        />
      </button-fi>
    </loading-indicator-wrapper>
  </div>
</template>

<script setup lang="ts">
import { ButtonFi, IconFi, LoadingIndicatorWrapper } from 'atoms';
import { computed } from 'vue';

import { useProductListStore } from '@/store/pinia/product-list';

defineOptions({ name: 'ProductBuyButtonFi' });

withDefaults(
  defineProps<{
    item?: Record<string, any> | null;
    productDetails?: Record<string, any>;
    isInProgress?: boolean;
    isButtonDisabled?: boolean;
    isButtonHidden?: boolean;
    inline?: boolean;
  }>(),
  {
    item: null,
    productDetails: () => ({}),
    isInProgress: false,
    isButtonDisabled: false,
    isButtonHidden: false,
    inline: false,
  },
);

defineEmits<{
  (e: 'add-product', productDetails: any): void;
}>();

const productListStore = useProductListStore();

const shopType = computed(() => productListStore.shopType);
</script>

<style scoped src="./product-buy-button-fi" />
